import http from "../http";

const AirportService = {

    GetAirportsService: async (IsUsed) => {
        const Airports = await http.instance.get("/Airport", {params: {IsUsed:IsUsed}});
        return Airports.data
    },

    GetAirportsServiceById:async(form) =>{
        console.log("Edit Airport GetAirpotsServiceById");
        console.log(form)
        console.log(form.id)
        console.log(form.isUsed)
        const Airport = await http.instance.get("/Airport/Id/", {params: {id: form.id,IsUsed:form.isUsed}});
        return Airport.data
    },

    UpdateAirport :async(form) =>{
        const Airport = await http.instance.post("/Airport/Edit",form)
        return Airport.data
    },

    DeleteAirport :async(form) =>{
        const Airport = await http.instance.post("/Airport/Delete",form)
        return Airport.data
    },

    AddAirport :async(addform) =>{
        const Airport = await http.instance.post("/Airport/Add",addform)
        return Airport.data
    }

};
export default AirportService;
